import { PublicAxios } from "./Helpers/publicInterceptorAxios";

const urlApi = process.env.REACT_APP_BACKEND_URL;

export const envioCorreo = async (data) => {
    return PublicAxios.post(`${urlApi}/api/api-externa/EnvioCorreoContacto`, data).then((res) => { return res.data })
}